<ion-content>
  <div *ngIf="!isInitialized" style="text-align: center; padding: 40px">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Checking subscription status...</p>
  </div>
  <ion-card
    style="margin-left: auto; margin-right: auto; margin-top: 10vh; max-width: 480px; padding: 10px"
    *ngIf="isInitialized"
  >
    <ion-card-header>
      <ion-icon name="mail-outline" style="font-size: 5rem; margin: -4px; color: #cfca95"></ion-icon>
      <ion-card-title style="font-size: 2rem">Manage email preferences</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-card class="outline-card" style="margin: 0 0 20px 0">
        <ion-list class="inner-list">
          <ion-item>
            <ion-label>
              <p>Email</p>
              <h3>{{ email }}</h3>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <p>Subscriptions</p>
              <h3 *ngIf="!isUnsubscribed"><ion-icon name="checkmark-outline"></ion-icon>Product updates</h3>
              <h3 *ngIf="isUnsubscribed"><ion-icon name="close-circle-outline"></ion-icon>None</h3>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card>

      <ion-button
        class="btn-large"
        size="block"
        fill="outline"
        [disabled]="isLoading"
        (click)="unsubscribe()"
        *ngIf="!isUnsubscribed"
      >
        <span [hidden]="isLoading"> <ion-icon name="close-circle" class="paddded-icon"></ion-icon> Unsubscribe </span>
        <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
      </ion-button>
      <ion-button class="btn-large" size="block" [disabled]="isLoading" (click)="resubscribe()" *ngIf="isUnsubscribed">
        <span [hidden]="isLoading"> Subscribe to updates </span>
        <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
      </ion-button>
    </ion-card-content>
  </ion-card>
</ion-content>
